import * as HomeContentGrid01Uploads from "$lib/data/generated/uploads/home/ContentGrid 01/uploads.js";
import * as HomeContentGrid02Uploads from "$lib/data/generated/uploads/home/ContentGrid 02/uploads.js";
import * as HomeFeatures01Uploads from "$lib/data/generated/uploads/home/Features 01/uploads.js";
import * as HomeFeatures02Uploads from "$lib/data/generated/uploads/home/Features 02/uploads.js";
import * as HomeFeatures03Uploads from "$lib/data/generated/uploads/home/Features 03/uploads.js";
import * as HomeFeatures05Uploads from "$lib/data/generated/uploads/home/Features 05/uploads.js";
import * as HomeFeatures06Uploads from "$lib/data/generated/uploads/home/Features 06/uploads.js";
import * as HomeFeaturesArticleGridUploads from "$lib/data/generated/uploads/home/Features Article Grid/uploads.js";
import * as HomeFeaturesMembershipsUploads from "$lib/data/generated/uploads/home/Features Memberships/uploads.js";
import * as HomeFeaturesServicesGridUploads from "$lib/data/generated/uploads/home/Features Services Grid/uploads.js";
import * as HomeHeadUploads from "$lib/data/generated/uploads/home/Head/uploads.js";
import * as HomePageBannerUploads from "$lib/data/generated/uploads/home/PageBanner/uploads.js";
import * as HomeSideBySide01Uploads from "$lib/data/generated/uploads/home/SideBySide 01/uploads.js";
import * as HomeSideBySide02Uploads from "$lib/data/generated/uploads/home/SideBySide 02/uploads.js";
import * as HomeSideBySide03Uploads from "$lib/data/generated/uploads/home/SideBySide 03/uploads.js";
import * as HomeTestimonialsUploads from "$lib/data/generated/uploads/home/Testimonials/uploads.js";

export const uploads = {
  ...HomeContentGrid01Uploads.uploads,
  ...HomeContentGrid02Uploads.uploads,
  ...HomeFeatures01Uploads.uploads,
  ...HomeFeatures02Uploads.uploads,
  ...HomeFeatures03Uploads.uploads,
  ...HomeFeatures05Uploads.uploads,
  ...HomeFeatures06Uploads.uploads,
  ...HomeFeaturesArticleGridUploads.uploads,
  ...HomeFeaturesMembershipsUploads.uploads,
  ...HomeFeaturesServicesGridUploads.uploads,
  ...HomeHeadUploads.uploads,
  ...HomePageBannerUploads.uploads,
  ...HomeSideBySide01Uploads.uploads,
  ...HomeSideBySide02Uploads.uploads,
  ...HomeSideBySide03Uploads.uploads,
  ...HomeTestimonialsUploads.uploads
};
